import { Box, Card, Grid, Skeleton as MuiSkeleton, Stack } from "@mui/material";
import { createDummyArray } from "../../../services/utils";

const VIDEO_HEIGHT = 120;
const TAB_SX = { flex: 1, borderRadius: "4px 4px 0 0" };
const BUTTON_ROUNDED_SX = { borderRadius: 1 };

export default function Skeleton() {
  return (
    <Card variant="outlined" sx={{ p: 2 }}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={4}>
          <Stack gap={2} sx={{ height: "100%", minHeight: 0 }}>
            <Box sx={{ position: "relative", width: "100%", height: VIDEO_HEIGHT, flexShrink: 0 }}>
              <MuiSkeleton
                variant="rectangular"
                sx={{ position: "absolute", inset: 0, borderRadius: 1 }}
              />
              <MuiSkeleton
                variant="rounded"
                width={140}
                height={40}
                sx={{
                  position: "absolute",
                  left: "50%",
                  top: "50%",
                  transform: "translate(-50%, -50%)",
                  borderRadius: 20,
                }}
              />
            </Box>

            <Stack gap={1.5}>
              {createDummyArray(4).map((_, i) => (
                <Stack key={i} direction="row" alignItems="center" gap={1}>
                  <MuiSkeleton variant="circular" width={20} height={20} />
                  <MuiSkeleton variant="text" width={i === 2 ? "40%" : "70%"} height={22} />
                </Stack>
              ))}
            </Stack>

            <Stack direction="row" spacing={2}>
              {createDummyArray(2).map((_, i) => (
                <MuiSkeleton
                  key={i}
                  variant="rounded"
                  width="100%"
                  height={40}
                  sx={{ ...BUTTON_ROUNDED_SX, flex: 1 }}
                />
              ))}
            </Stack>
          </Stack>
        </Grid>

        <Grid item xs={12} md={8}>
          <Stack gap={2} sx={{ height: "100%", minHeight: 0, overflow: "auto" }}>
            <Stack direction="row" spacing={0} sx={{ width: "100%" }}>
              {createDummyArray(2).map((_, i) => (
                <MuiSkeleton key={i} variant="rounded" height={40} sx={TAB_SX} />
              ))}
            </Stack>

            <Stack gap={2}>
              {createDummyArray(5).map((_, i) => (
                <Stack key={i} direction="row" gap={1.5} alignItems="flex-start">
                  <MuiSkeleton variant="circular" width={8} height={8} sx={{ mt: 1.25, flexShrink: 0 }} />
                  <Stack gap={0.5} sx={{ flex: 1 }}>
                    {[95, 80, 60].map((w) => (
                      <MuiSkeleton key={w} variant="text" width={`${w}%`} height={20} />
                    ))}
                  </Stack>
                </Stack>
              ))}
            </Stack>
          </Stack>
        </Grid>
      </Grid>
    </Card>
  );
}
